var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',_vm._b({attrs:{"fullObject":_vm.fullObject},on:{"update:fullObject":function($event){return _vm.$emit('update:fullObject', $event)}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'FormulateInput',_vm.field,false))
}
var staticRenderFns = []

export { render, staticRenderFns }